<template>
    <div class="container-fluid mt-4" :class="{'loading': loading.data}">
        <div class="row">
            <template v-if="invitations && invitations.length">
                <invitations-table :class="{'loading': loading.invitations}" :data="invitations">
                </invitations-table>
                <div class="divider --vertical-20"></div>
            </template>
            <team-table role="caregiver"
                        :data="caregivers"
                        showAddBtn="true"
                        @add-caregiver="addTeamMember('caregiver')"
                        @edit-team-member="editTeamMember"
            >
            </team-table>
            <div class="divider --vertical-20"></div>
            <team-table role="professional"
                        :data="professionals"
                        showAddBtn="true"
                        @add-professional="addTeamMember('professional')"
                        @edit-team-member="editTeamMember"
            >
            </team-table>
        </div>
        <modal name="addTeamMemberModal" height="auto" width="640px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="w-100 text-left" style="position: relative">
                        <h4 class="modal-title dashboard-card-title">{{edit ? 'Edit' : 'Invite a new'}} {{teamMember.role}}</h4>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('addTeamMemberModal')"></button>
                    </div>
                </div>
                <div class="modal-subtitle">
                    The individual will receive an email notification that you've invited them to your team.
                </div>
                <div class="modal-body">
                    <form-group>
                        <form-input :readonly="edit" class="mb-2" inputClass="form-control-lg" label="Email" placeholder="Enter email"
                                    v-model="teamMember.email" :v="$v.teamMember.email"/>
                        <form-select inputClass="form-select-lg"
                                     v-if="teamMember.role === 'caregiver'"
                                     label="Role"
                                     class="mb-2"
                                     v-model="teamMember.profession"
                                     :options="[
                                        {'label': 'Mom', 'value': 'mom'},
                                        {'label': 'Dad', 'value': 'dad'},
                                     ]"
                        />
                        <form-select inputClass="form-select-lg"
                                     v-if="teamMember.role === 'professional'"
                                     label="Role"
                                     class="mb-2"
                                     v-model="teamMember.profession"
                                     :options="[
                                        {'label': 'Teacher', 'value': 'teacher'},
                                        {'label': 'Psychologist', 'value': 'psychologist'},
                                     ]"
                        />
                    </form-group>
                </div>
                <div class="modal-footer">
                    <btn class="btn-outline-light btn-lg" @click="$modal.hide('addTeamMemberModal')">Cancel</btn>
                    <btn class="btn-primary btn-lg" :loading="loading.save" @click="saveTeamMember()">{{ edit ? 'Save' : 'Add'}}</btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import TeamTable from "@/components/TeamTable.vue";
import {required} from "vuelidate/lib/validators";
import UserFromGroupSelect from "@/components/UserFromGroupSelect.vue";
import InvitationsTable from "@/components/InvitationsTable.vue";

export default {
  name: 'TeamMembers',
  components: {InvitationsTable, UserFromGroupSelect, TeamTable},
  data() {
    return {
      loading: {
        data: false,
        save: false,
        invitations: false,
      },
      edit: false,
      teamMember: {
        name: '',
        email: '',
        role: 'professional',
      },
      professionals: [],
      caregivers: [],
      invitations: []
    };
  },
  validations: {
    teamMember: {
      email: {required: required},
      profession: {required: required},
    },
  },
  mounted() {
    this.getTeamMembers();
    this.getInvitations();
    this.$events.$on('loadTeamMembers', this.getTeamMembers);
    this.$events.$on('loadInvitations', this.getInvitations);
  },
  methods: {
    getTeamMembers() {
      this.loading.data = true;
      this.$http.post("/hero/get-team-members", {id: this.$route.params.hero_id})
        .then((res) => {
          this.professionals = res.body.data.professionals;
          this.caregivers = res.body.data.caregivers;
          this.getInvitations();
          this.loading.data = false;
        })
        .catch((error) => {
          this.loading.data = false;
        });
    },
    addTeamMember(role) {
      this.edit = false;
      this.teamMember = {
        hero_id: this.$route.params.hero_id,
        name: '',
        email: '',
        role: role,
        profession: ''
      };
      this.$modal.show('addTeamMemberModal');
    },
    editTeamMember(user) {
      this.edit = true;
      this.teamMember = user;
      this.$modal.show('addTeamMemberModal');

    },
    saveTeamMember() {
      this.$v.teamMember.$touch();
      if (this.$v.teamMember.$invalid == true) {
        return false;
      }
      this.loading.save = true;
      let url = this.edit ? "/hero/edit-team-member" : "/hero/add-team-member";
      this.$http.post(url, this.teamMember)
        .then((res) => {
          this.loading.save = false;
          this.getTeamMembers();
          this.$modal.hide('addTeamMemberModal');
        })
        .catch((error) => {
          this.loading.save = false;
        });
    },
    getInvitations() {
      this.loading.invitations = true;
      this.$http.post("/hero/invitations", {hero_id: this.$route.params.hero_id})
        .then((res) => {
          this.invitations = res.body.data;
          this.loading.invitations = false;
        })
        .catch((error) => {
          this.loading.invitations = false;
        });
    },
  },
};
</script>
